/**
 * Detects if the current device is mobile/tablet.
 *
 * Strategy (in order):
 * 1. navigator.userAgentData.mobile  — modern Chromium browsers
 * 2. UA string regex                 — covers Android, iPhone, older devices
 * 3. Touch + small screen fallback   — catches iPadOS 13+ which lies about UA
 */
export function isMobileDevice() {
  // 1. Modern API (Chrome, Edge, Samsung Internet)
  if (typeof navigator.userAgentData !== "undefined") {
    return navigator.userAgentData.mobile;
  }

  const ua = navigator.userAgent;

  // 2. UA string regex — covers most phones and older tablets
  const mobileUA = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|silk|kindle/i.test(ua);
  if (mobileUA) return true;

  // 3. iPadOS 13+ pretends to be desktop Safari — catch it via touch + screen size
  const isIPadOS =
    /Macintosh/i.test(ua) &&
    navigator.maxTouchPoints > 1;

  if (isIPadOS) return true;

  // 4. Any touch device with a small screen (phones that slipped past regex)
  const hasTouch = navigator.maxTouchPoints > 0 || "ontouchstart" in window;
  const smallScreen = window.screen.width <= 768;
  if (hasTouch && smallScreen) return true;

  return false;
}